import { reduxForm } from 'redux-form';
import { connect } from 'react-redux'

import { editPassword } from '../../actions/settings_actions';
import UserPassword from '../../components/Settings/userPassword';

function mapStateToProps(state) {
  return {
    editUserDetailSuccess: state.settings.editUserDetailSuccess,
    editPasswordIsLoading: state.settings.editPasswordIsLoading,
    initialValues: state.settings.userDetail,
    editPasswordError: state.settings.editPasswordError,
  }
}

const userPassword = reduxForm({
  form: 'userPassword'
})(UserPassword);

export default connect(mapStateToProps, { editPassword })(userPassword)



// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/userPassword.jsx